import { Box, LinearProgress, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { PHASES, RETENTION_STAGES } from '../constants/stages';
import { IconBadge } from './ui';

// Slim banner at the top of a phase tab: icon, phase name, stage range and how far along it is.
export default function PhaseHeader({ phase: phaseNo, currentStage }) {
  const phase = PHASES[phaseNo];
  const stages = RETENTION_STAGES.filter((s) => s.phase === phaseNo);
  const first = stages[0].no;
  const last = stages[stages.length - 1].no;
  const done = Math.min(stages.length, Math.max(0, currentStage - first));
  const pct = Math.round((done / stages.length) * 100);

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={2}
      sx={{ p: 2, borderRadius: 4, background: phase.light, border: `1px solid ${alpha(phase.color, 0.2)}` }}
    >
      <IconBadge icon={phase.icon} color={phase.color} size={44} solid sx={{ background: phase.gradient }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="h6" sx={{ color: phase.color }}>
          {phase.label}
        </Typography>
        <Typography variant="caption" sx={{ fontWeight: 700, color: phase.color, opacity: 0.8 }}>
          Stages {first}–{last} · {done}/{stages.length} done
        </Typography>
      </Box>
      <Box sx={{ width: { xs: 90, sm: 180 } }}>
        <LinearProgress
          variant="determinate"
          value={pct}
          sx={{ bgcolor: alpha(phase.color, 0.15), '& .MuiLinearProgress-bar': { background: phase.gradient } }}
        />
      </Box>
    </Stack>
  );
}
